export interface FieldOkObjekt {
  id: number,
  objekt: string,
  bezeichnung: string,
}
